import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import PasswordChangeModal from './PasswordChangeModal';
import styles from './UserMenu.module.css';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [pwModal, setPwModal] = useState(false);

  if (!user) return null;
  const initial = (user.name || user.email || '?').charAt(0).toUpperCase();

  async function handleLogout() {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  }

  function goAdmin() {
    setOpen(false);
    navigate('/admin');
  }

  function openPwModal() {
    setOpen(false);
    setPwModal(true);
  }

  return (
    <div className={styles.root}>
      <button className={styles.button} onClick={() => setOpen(o => !o)} aria-label="User menu">
        {initial}
      </button>
      {open && (
        <>
          <div className={styles.backdrop} onClick={() => setOpen(false)} />
          <div className={styles.menu}>
            <div className={styles.userInfo}>
              <div className={styles.name}>{user.name}</div>
              <div className={styles.email}>{user.email}</div>
            </div>
            <button className={styles.item} onClick={openPwModal}>비밀번호 변경</button>
            {user.is_admin && (
              <>
                <div className={styles.divider} />
                <button className={styles.item} onClick={goAdmin}>Admin</button>
              </>
            )}
            <div className={styles.divider} />
            <button className={styles.item} onClick={handleLogout}>로그아웃</button>
          </div>
        </>
      )}
      {pwModal && <PasswordChangeModal onClose={() => setPwModal(false)} />}
    </div>
  );
}
